import router from '@/router'
import { authServices } from '../services/auth'
import { applyThemeClass, persistTheme, THEME_DARK, THEME_LIGHT } from '@/utils/theme'

export const actions = {
    setLoading ({commit}, payload) {
        commit('setLoading', payload)
    },
    // KAN-95 暗室暗色主題：使用者主動切換（更新 state + 套 root class + 持久化）
    setUiTheme ({ commit }, theme) {
        const next = theme === THEME_DARK ? THEME_DARK : THEME_LIGHT
        commit('SET_UI_THEME', next)
        applyThemeClass(next)
        persistTheme(next)
    },
    // 在亮 / 暗之間切換
    toggleUiTheme ({ state, dispatch }) {
        const next = state.ui.theme === THEME_DARK ? THEME_LIGHT : THEME_DARK
        dispatch('setUiTheme', next)
    },
    setLoadingDescript ({commit}, payload) {
        commit('setLoadingDescript', payload)
    },
    setUser ({ commit }, user) {
        commit('setUser', user)
    },
    async login ({ commit, dispatch }, payload) {
        commit('setLoading', true)

        try {
            const res = await authServices.signIn(payload.username, payload.password)

            if (res.result === 'success') {
                dispatch('setUser', res)
                
                commit('setError', null)

                // send user to homepage
                router.push('/home')
            } else {
                commit('setError', 'auth')
            } 
        } catch (e) {
            console.log(e)
        } finally {
            commit('setLoading', false)
        }
    },
    logout ({ dispatch }) {
        dispatch('setUser', null)
        window.location.assign('/')
    },
    setSetting({commit}, setting) {
        commit('SET_SETTING', setting)
    },
    // 醫院別配置注入（main.js mount 前呼叫）
    setHospital({commit}, hospital) {
        commit('SET_HOSPITAL', hospital)
    }
}